<script setup lang="ts">
import { FontAwesomeIcon } from '@shared/plugin/icons';

const props = defineProps<{ title: string; icon?: string }>();
const emit = defineEmits<{ click: [] }>();
const isInEditMode = defineModel<boolean>('modelValue');

function toggleEditMode() {
  isInEditMode.value = !isInEditMode.value;
  emit('click');
}
</script>

<template>
  <button
    :aria-label="`bewerk ${props.title.toLowerCase()}`"
    class="flex size-8 items-center justify-center rounded hover:bg-grey-200 focus:outline-none"
    type="button"
    @click="toggleEditMode"
  >
    <FontAwesomeIcon
      :icon="props.icon ?? (isInEditMode ? 'fas fa-xmark' : 'fas fa-pen')"
      class="text-primary-900"
    />
  </button>
</template>
